import { useState } from "react";
import { motion } from "framer-motion";
import Button from "../ui/Button";
import { BsCameraVideo, BsCalendar, BsClock } from "react-icons/bs";

export default function ConsultationBooking() {
  const [step, setStep] = useState(1);
  const [booking, setBooking] = useState({
    date: "",
    time: "",
    name: "",
    email: "",
    concerns: "",
  });

  const availableTimes = ["09:00", "10:00", "11:00", "14:00", "15:00", "16:00"];

  const handleSubmit = (e) => {
    e.preventDefault();
    // Add booking submission logic here
    alert("Consultation booked successfully!");
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-md">
      <h2 className="text-2xl font-serif font-bold text-primary-900 mb-6">
        Book a Virtual Hair Consultation
      </h2>

      <div className="space-y-8">
        {step === 1 && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="space-y-4"
          >
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Select Date
              </label>
              <input
                type="date"
                value={booking.date}
                onChange={(e) =>
                  setBooking((prev) => ({ ...prev, date: e.target.value }))
                }
                className="w-full rounded-md border-gray-300 focus:border-primary-500 focus:ring-primary-500"
                min={new Date().toISOString().split("T")[0]}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Available Times
              </label>
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
                {availableTimes.map((time) => (
                  <button
                    key={time}
                    onClick={() => setBooking((prev) => ({ ...prev, time }))}
                    className={`p-2 rounded-md border ${
                      booking.time === time
                        ? "border-primary-600 bg-primary-50"
                        : "border-gray-300"
                    }`}
                  >
                    {time}
                  </button>
                ))}
              </div>
            </div>

            <Button onClick={() => setStep(2)} fullWidth>
              Next
            </Button>
          </motion.div>
        )}

        {step === 2 && (
          <motion.form
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            onSubmit={handleSubmit}
            className="space-y-4"
          >
            <input
              type="text"
              placeholder="Your Name"
              value={booking.name}
              onChange={(e) =>
                setBooking((prev) => ({ ...prev, name: e.target.value }))
              }
              className="w-full rounded-md border-gray-300 focus:border-primary-500 focus:ring-primary-500"
              required
            />
            <input
              type="email"
              placeholder="Your Email"
              value={booking.email}
              onChange={(e) =>
                setBooking((prev) => ({ ...prev, email: e.target.value }))
              }
              className="w-full rounded-md border-gray-300 focus:border-primary-500 focus:ring-primary-500"
              required
            />
            <textarea
              placeholder="Hair Concerns & Questions"
              value={booking.concerns}
              onChange={(e) =>
                setBooking((prev) => ({ ...prev, concerns: e.target.value }))
              }
              rows={4}
              className="w-full rounded-md border-gray-300 focus:border-primary-500 focus:ring-primary-500"
              required
            />
            <div className="flex space-x-4">
              <Button variant="outline" onClick={() => setStep(1)}>
                Back
              </Button>
              <Button type="submit" fullWidth>
                Book Consultation
              </Button>
            </div>
          </motion.form>
        )}
      </div>
    </div>
  );
}
